<template>
  <div v-if="list.length > 0">
    <div class="attended-presentation-list">
      <div
        v-for="item in list"
        :key="item.id"
        class="attended-item"
        @click="handleReviewPresentationClick(item)"
      >
        <div class="attended-item-thumbnail">
          <div class="img-placeholder">
            <img
              v-if="item.thumbnailImage || item.customThumbnailImage"
              :src="item.thumbnailImage || item.customThumbnailImage"
              alt="Presentation thumbnail"
            >
            <img
              v-else
              src="@/assets/images/default-thumbnail.svg"
              alt="Presentation thumbnail"
            >
          </div>
        </div>
        <div class="attended-item-desc">
          <div class="attended-item-title">
            {{ item.name }}
          </div>
          <div class="attended-item-date">
            <i class="fas fa-clock icon" />
            <span>{{ formatDate(item.joinAt) }}</span>
          </div>
        </div>
      </div>
    </div>
    <p class="text-note">
      {{ $t('your_future_presentations_shown_here') }}
    </p>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import util from '@/util'

export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleReviewPresentationClick(item) {
      this.$router.push({
        name: 'Profile',
        params: {
          id: item.uniqueAccessCode,
        },
        query: {
          'attended-presentation-detail': item.uniqueAccessCode,
        },
      })

      util.ga4Track('Account > View an attended presentation', {
        presentationId: item.id,
      })
    },
    formatDate(date) {
      return dayjs(date).fromNow()
    },
  },
}
</script>

<style lang="scss" scoped>
.attended-item {
  display: flex;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 1px 3px 0px #D3D7E1CF;
}

.attended-item-thumbnail {
  .img-placeholder {
    width: 132px;
    padding-top: 56.25%;
    position: relative;
    overflow: hidden;
    border-radius: 4px;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.attended-item-desc {
  padding: 6px 0 6px 16px;

  .attended-item-title {
    font-size: 0.875rem;
    color: #282E3E;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
  }

  .attended-item-date {
    margin-top: 8px;
    font-size: 0.75rem;

    .icon {
      font-size: 0.875rem;
      margin-right: 6px;
      color: #999999;
    }
  }
}

.text-note {
  padding-bottom: 16px;
  color: #707070;
  text-align: center;
  font-size: 0.875rem;
}
</style>
